export default "__VITE_ASSET__LgvCry5X__"